import Icon from '@atoms/Icon/Icon';
import Text from '@atoms/Text/Text';
import SiteEnum from '@models/enums/SiteEnum';
import { slideTransition } from '@utility/config/animations';
import useModal from '@utility/hooks/useModal';
import classNames from 'classnames';
import { AnimatePresence, motion } from 'motion/react';
import { PropsWithChildren, useRef } from 'react';
import Portal from './Portal';

export interface IFullScreenModal {
  readonly closeLabel?: string;
  readonly isOpen: boolean;
  readonly setIsOpen: (state: boolean) => void;
  readonly site?: SiteEnum;
  readonly title: string;
}

const FullScreenModal = ({
  children,
  closeLabel = 'close',
  isOpen,
  setIsOpen,
  site = SiteEnum.B2B,
  title,
}: PropsWithChildren<IFullScreenModal>) => {
  const targetRef = useRef<HTMLDivElement>(null);

  useModal(isOpen, setIsOpen, targetRef);

  return (
    <AnimatePresence>
      {isOpen && (
        <Portal key="portal" mountId="portal-mount">
          <motion.div
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={slideTransition}
            key="drawer"
            role="complementary"
            ref={targetRef}
            tabIndex={0}
            className={classNames(
              'tw-fixed tw-inset-0 tw-z-max tw-outline-none',
              site === SiteEnum.B2B
                ? 'tw-bg-grey-10'
                : 'tw-top-[56px] tw-h-[calc(100vh-56px)] tw-bg-white'
            )}
            id="filters-modal"
          >
            <div className="tw-relative tw-flex tw-h-full tw-w-full tw-flex-col">
              <div
                className={classNames(
                  'tw-flex tw-w-full tw-items-center tw-justify-between tw-bg-grey-10 tw-outline-none xl:tw-hidden',
                  site === SiteEnum.B2B
                    ? 'tw-border-b tw-border-grey-20 tw-p-xs'
                    : 'tw-bg-grey-10 tw-p-md tw-pb-xs'
                )}
              >
                {/* <Text variant="body-14-semibold">{title}</Text> */}
                <Text variant="heading-28">{title}</Text>
                <button
                  type="button"
                  aria-label={closeLabel}
                  onClick={() => setIsOpen(false)}
                >
                  <Icon
                    name="cross"
                    size={site === SiteEnum.B2B ? '1rem' : '1.5rem'}
                  />
                </button>
              </div>
              {children}
            </div>
          </motion.div>
        </Portal>
      )}
    </AnimatePresence>
  );
};

export default FullScreenModal;
